import React, { useMemo, useState } from "react";
import {OrderId, BillingName, PaymentStatus, Date} from "./RequisitionCol";
import { Button } from "reactstrap";

const useMemoRequisitionCols = (handleGetDocumentDownload, handleContinueRequisition, handleGetDocumentAllDownload) => {
    return useMemo(() => [
        {
        Header: 'No.',
        accessor: 'id',
        width: '150px',
        style: {
          textAlign: "center",
          width: "10%",
          background: "#0000",
        },
        filterable: true,
        filterRemote: true,
        Cell: (cellProps) => {
          return <OrderId {...cellProps} />;
        }
      },
      {
        Header: 'Fecha de Creación',
        accessor: 'created_at_f',
        disableFilters: true,
        
        Cell: (cellProps) => {
          return <Date {...cellProps} />;
        }
      },
      {
        Header: 'Asunto',
        accessor: 'det',
        disableFilters: true,        
        Cell: (cellProps) => {
            return <BillingName {...cellProps} />;
        }
      },
      {
        Header: 'Status',
        accessor: 'status',
        disableFilters: true,
        Cell: (cellProps) => {
            return <PaymentStatus {...cellProps} />;
        }
      },
      {
        Header: 'Doc 1',
        accessor: 'action',
        style: {
            textAlign: "center",
            background: "#0000",
          },
        disableFilters: true,
        Cell: (cellProps) => {
          const reqData = cellProps.row.original;
          {
          return (reqData?.det?.length>0 && reqData?.det[0]?.id ?
            
                <div className="d-flex gap-3">
                    <Button onClick={(e)=>handleGetDocumentDownload(reqData?.det[0], e)} >
                        <i className="fas fa-eye"></i>
                    </Button>              
                </div>:"")
            }
        }
      },
      {
        Header: 'Doc 2',
        accessor: 'action2',
        disableFilters: true,
        Cell: (cellProps) => {
          const reqData = cellProps.row.original;
          {
          return (reqData?.det?.length>1 && reqData?.det[1]?.id ?
            
                <div className="d-flex gap-3">
                    <Button onClick={(e)=>handleGetDocumentDownload(reqData?.det[1], e)} >
                        <i className="fas fa-eye"></i>
                    </Button>              
                </div>:<Button color="primary" onClick={(e)=>handleContinueRequisition(reqData, e)} >
                        <i className="fas fa-angle-double-right"></i> 
                    </Button>)
            }
        }
      },
      {
        Header: 'Doc 3',
        accessor: 'action3',
        disableFilters: true,
        Cell: (cellProps) => {
          const reqData = cellProps.row.original;
          {
          return (reqData?.det?.length>2 && reqData?.det[2]?.id ?
            
                <div className="d-flex gap-3">
                    <Button onClick={(e)=>handleGetDocumentDownload(reqData?.det[2], e)} >
                        <i className="fas fa-eye"></i>
                    </Button>              
                </div>:reqData?.det?.length==2 ? <Button color="primary" onClick={(e)=>handleContinueRequisition(reqData, e)} >
                <i className="fas fa-angle-double-right"></i> 
                    </Button>:"")
            }
        }
      },
      {
        Header: 'Doc 4',
        accessor: 'action4',
        disableFilters: true,
        Cell: (cellProps) => {
          const reqData = cellProps.row.original;
          {
          return (reqData?.det?.length>3 && reqData?.det[3]?.id ?
            
                <div className="d-flex gap-3">
                    <Button onClick={(e)=>handleGetDocumentDownload(reqData?.det[3], e)} >
                        <i className="fas fa-eye"></i>
                    </Button>              
                </div>: reqData?.det?.length==3 ?<Button color="primary" onClick={(e)=>handleContinueRequisition(reqData, e)} >
                <i className="fas fa-angle-double-right"></i> 
                    </Button>:"")
            }
        }
      },{
        Header: 'Todo',
        accessor: 'action5',
        disableFilters: true,
        Cell: (cellProps) => {
          const reqData = cellProps.row.original;
          {
            return (reqData?.status==="Completo" ?
              <div className="d-flex gap-3">
                <button className="btn-warning btn btn-sm" onClick={(e)=>handleContinueRequisition(reqData, e)} >
                  <i className=" fas fa-edit "></i> 
                    </button>
                <Button color="primary" onClick={(e)=>handleGetDocumentAllDownload(reqData)} >
                  <i className="fas fa-eye"></i>
                </Button>
              </div>:"")
          }
        }
      },
    ],[]);  
}

export {useMemoRequisitionCols};